type UsuarioNome = {
  apelido?: string | null;
  nome?: string | null;
};

export default function getUsuarioNomeExibicao(
  usuario?: UsuarioNome | null,
): string {
  const apelido = usuario?.apelido?.trim();
  if (apelido) return apelido;

  const nome = usuario?.nome?.trim();
  return nome?.split(/\s+/)[0] || '';
}
